import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/${dossierId}/InsuranceCarrierComponentHistorical`, method: 'GET', token: token })
}
